// extracted by mini-css-extract-plugin
export default {"container":"FollowLimitModal_container__qPxgG","primaryText":"FollowLimitModal_primaryText__SVdTC","confirmButton":"FollowLimitModal_confirmButton__-S9Em"};